import React from "react";
import PropTypes from "prop-types";
import { graphql, useStaticQuery } from "gatsby";
import "../scss/loaderLogo.scss";

const LoaderLogo = props => {
  const { loaderImage } = useStaticQuery(graphql`
    query MyQuery {
      loaderImage: file(relativePath: { eq: "loader-logo-inner.png" }) {
        publicURL
      }
    }
  `);

  const styles = {
    backgroundImage: `url(${loaderImage.publicURL})` || ""
  };
  const { showLoader } = props;
  return (
    <div className={"loading " + (showLoader ? "d-block" : "d-none")}>
      <div className="logo"></div>
      <div className="logo-inner" style={styles}></div>
    </div>
  );
};

LoaderLogo.propTypes = {
  showLoader: PropTypes.bool.isRequired
};

export default LoaderLogo;
